import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { VaultDetail } from './vault-detail';

const WrapAuth = withAuth(VaultDetail);
const WrappedVaultDetail = withLayout(LayoutType.Empty, WrapAuth);

export { WrappedVaultDetail as VaultDetail };
